var config = {
    timestampOffset: null,
    defaultOffset: null
};
export default config;
